import React from 'react'
// ##
import PendingBuyersTable from '../../modules/PendingBuyers/components/PendingBuyersTable'

export default function PendingBuyersPage() {
  return <PendingBuyersTable />
}
